module.exports = __webpack_public_path__ + "img/meet-kristen.3b63a2ef.jpg";